import React from "react";
import FormButton from "../Button/MatchingFormButton";

const FormTitle = (props) => {
  return (
    <React.Fragment>
      <h2 className=" headline-5">{props.formTitle}</h2>
      <FormButton formIsOpen={props.formIsOpen} />
    </React.Fragment>
  );
};

export default FormTitle;
